import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { ShepherdService } from 'angular-shepherd';

@Injectable({
  providedIn: 'root'
})
export class ToursService {
  startTour$: ReplaySubject<number> = new ReplaySubject();
  startVariationsTour$: ReplaySubject<number> = new ReplaySubject();
  startLeadTaskTour$: ReplaySubject<number> = new ReplaySubject();

  constructor(
    private shepherdService: ShepherdService,
  ) {

  }

  get tourTextVariationsNotShow(): boolean {
    return !!localStorage.getItem('text_variations_tour');
  }

  set tourTextVariationsNotShow(val) {
    if (val) {
      this.shepherdService.complete();
      this.shepherdService.onTourFinish('Cancel user');
    }
    localStorage.setItem('text_variations_tour', new Date().getTime().toString());
  }

  get tourLeadTaskNotShow(): boolean {
    return !!localStorage.getItem('lead_task_tour');
  }

  set tourLeadTaskNotShow(val) {
    if (val) {
      this.shepherdService.complete();
      this.shepherdService.onTourFinish('Cancel user');
    }
    localStorage.setItem('lead_task_tour', new Date().getTime().toString());
  }
}
